module.exports = __webpack_public_path__ + "static/media/logo_club.eeb82573.png";